__turbopack_context__.v({
  "cardTitle": "JWE4ba_cardTitle" + " " + __turbopack_context__.i(515534)["cardTitle"],
  "contentContainer": "JWE4ba_contentContainer",
  "featureCard": "JWE4ba_featureCard",
  "featureImage": "JWE4ba_featureImage",
  "featuresGrid": "JWE4ba_featuresGrid",
  "heading": "JWE4ba_heading" + " " + __turbopack_context__.i(515534)["sectionHeading"],
  "section": "JWE4ba_section",
  "textContainer": "JWE4ba_textContainer",
});
